(function ($, SCS) {
	'use strict';

	/**
	 *  use by forms/components/form/capthca
	 *  defined Callback function for https://www.google.com/recaptcha/api.js
	 *  Synchronize call createCaptcha from Tc.Module.Captcha and google API
	 */
	SCS.captcha = SCS.captcha || {};

	$.extend(SCS.captcha, {

		onloadCaptchaCallback: function () {

			/*
			 * apply wrapper
			 *
			 * @param array parameterArray An array comprising either:
			 *      [ ctx, functionObject, optional_parameters ]
			 */
			function apply () {
				var parameterArray, f, ctx, form, ajaxCaptcha;

				if(arguments.length>0){
					parameterArray = arguments[0];
					ctx = parameterArray.shift();
					f = parameterArray.shift();
					f.apply(ctx, parameterArray);

					//detach ajaxCaptcha if exists, only one Captcha field is allow.
					form = ctx.$ctx.closest('form');
					if(form && form.length > 0){
						ajaxCaptcha = form.find('.modAjaxCaptcha');
						if(ajaxCaptcha && ajaxCaptcha.length >0){
							ajaxCaptcha.detach();
						}
					}

				}

			}

			if (SCS.captcha.captchaHandler && $.isArray(SCS.captcha.captchaHandler) && $('#captcha').length) {
				//SCS.captchaHandler with handlers

				for (var iterator = 0; iterator < SCS.captcha.captchaHandler.length; iterator++) {
					if (SCS.captcha.captchaHandler[iterator]) {
						apply(SCS.captcha.captchaHandler[iterator]);
					}
				}

			}

			function CaptchaHandlerProxy () {
				return {
					push: apply
				};
			}

			// replace initialization array with proxy object
			SCS.captcha.captchaHandler = new CaptchaHandlerProxy();

		}
	});

	// asynchronous (or proxy)
	if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
		SCS.captcha.captchaHandler = [];
	}

}(window.$, window.SCS = window.SCS || {}));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/SCS.Captcha.js
// module id = 36
// module chunks = 0